import PocketBase from 'pocketbase';

// Get the PocketBase URL from environment variables
const pbUrl = import.meta.env.VITE_POCKETBASE_URL;

if (!pbUrl) {
  throw new Error('VITE_POCKETBASE_URL environment variable is not set');
}

// Create and export a PocketBase client instance
export const pb = new PocketBase(pbUrl);

// Disable request auto cancellation
pb.autoCancellation(false);

// Try to refresh token on app start if there's a valid token
export const tryRefreshToken = async () => {
  if (pb.authStore.isValid) {
    try {
      // Try to refresh the token
      await pb.collection('users').authRefresh();
      return true;
    } catch {
      // Clear auth store on failed refresh
      pb.authStore.clear();
      return false;
    }
  }
  return false;
}; 